import { BrowserModule } from '@angular/platform-browser';
import { NgModule, HostListener,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import {MessagesModule} from 'primeng/messages';
import {MenuModule} from 'primeng/menu';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import {MenuItem} from 'primeng/api';
import { NgScrollbarModule } from 'ngx-scrollbar';
import {PickListModule} from 'primeng/picklist';
import {TableModule} from 'primeng/table';
import {MessageModule} from 'primeng/message';
import {SplitButtonModule} from 'primeng/splitbutton';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './../welcome/welcome.component';
import { NavbarComponent } from './../navbar/navbar.component';
// CAP-40007 TCL-2727 - PingFederate OIDC module replaces the legacy LoginComponent
import { OAuthModule } from 'angular-oauth2-oidc';
import { OidcAuthService } from './auth/oidc-auth.service';
import {ToastModule} from 'primeng/toast';
import {DropdownModule} from 'primeng/dropdown';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {RouterModule} from '@angular/router';
import {appRoutes} from './route';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AgGridModule} from "ag-grid-angular/main";
// CAp-40007 TCL-2727 - Import AuthInterceptor for JWT token authorization
import { AuthInterceptor } from './auth/auth.interceptor';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {PasswordModule} from 'primeng/password';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DialogModule} from 'primeng/dialog';
import { HttpModule } from '@angular/http';
import { HeaderComponent } from './header/header.component';
import { TopmenuComponent } from './topmenu/topmenu.component';
import { SaisieComponent } from './saisie/saisie.component';
import { AdministrationComponent } from './administration/administration.component';
import { ExtractionComponent } from './extraction/extraction.component';
import { TopicComponent } from './topic/topic.component';
import {MessageService, ConfirmationService} from 'primeng/api';
import {CheckboxModule} from 'primeng/checkbox';
import {ListboxModule} from 'primeng/listbox';
import {TooltipModule} from 'primeng/tooltip';
import { TextareaComponent } from './textarea/textarea.component';
import { ImageService } from './image-upload/image.service';
import { FileDropDirective } from './file-drop.directive';
import { AppConfig } from './app.config';
import { APP_INITIALIZER } from '@angular/core';
import { environment } from '../environments/environment';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { NgxSmartModalModule,NgxSmartModalService } from 'ngx-smart-modal';
import {FileUploadModule} from 'primeng/fileupload';
import { ImageareaComponent } from './imagearea/imagearea.component';
import {CardModule} from 'primeng/card';
import {AuthGuardService} from './auth/auth-guard.service';
import {AuthService} from './auth/auth.service';
// CAP-40007 TCL-22 - RBAC services: centralized authorization + area route guard.
import { AuthorizationService } from './auth/authorization.service';
import { RoleGuardService } from './auth/role-guard.service';
import {SnackbarModule} from 'ngx-snackbar';
import { TextSelectDirective } from './directive/text-select.directive';
import { ComplexApplicabilityComponent } from './complex-applicability/complex-applicability.component';
import { TagInputModule } from 'ngx-chips';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { TextUppercaseDirective } from './directive/text-uppercase.directive';
import { InformationImageService } from './service/Image/image.service';
import { BillingService } from './service/billing/billing.service';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { CustomNoRowsOverlay } from './extraction/no-rows-overlay/custom-no-rows-overlay.component';
import { ValidatePipe } from './administration/validate.pipe';
import { ParameterComponent } from './administration/parameter/parameter.component';
import { DatacollectionComponent } from './administration/datacollection/datacollection.component';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { CreateParameterComponent } from './administration/create-parameter/create-parameter.component';
import { EditBaseTopicsComponent } from './administration/edit-base-topics/edit-base-topics.component';
import { SearchPipe } from './administration/edit-base-topics/search.pipe';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { NgxCoolDialogsModule } from 'ngx-cool-dialogs';
import { ApplicabilityFilterPipe } from './pipe/applicability-filter.pipe';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// CAP-40007 TCL-2727 - Single APP_INITIALIZER: load config.json first, then configure OAuthService
// in the .then() chain. APP_INITIALIZER providers run in parallel (Promise.all), so splitting them
// into two separate providers causes initializeOidc to race against the async config load and read
// AppConfig.settings while it is still undefined. Chaining configure() here guarantees sequencing.
export function initializeApp(appConfig: AppConfig, oidc: OidcAuthService) {
  return () => {
    return appConfig.load(environment.configFile).then(() => {
      oidc.configure();
    });
  };
}


@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    CustomNoRowsOverlay,
    NavbarComponent,
    HeaderComponent,
    TopmenuComponent,
    ComplexApplicabilityComponent,
    SaisieComponent,
    AdministrationComponent,
    ExtractionComponent,
    TopicComponent,
    TextareaComponent,
    FileDropDirective,
    ImageUploadComponent,
    ImageareaComponent,
    TextSelectDirective,
    TextUppercaseDirective,
    ValidatePipe,
    ParameterComponent,
    DatacollectionComponent,
    CreateParameterComponent,
    EditBaseTopicsComponent,
    SearchPipe,
    ApplicabilityFilterPipe
  ],
  entryComponents: [
    TextareaComponent,
    ImageareaComponent,
    CustomNoRowsOverlay,
    ParameterComponent,
    DatacollectionComponent,
    CreateParameterComponent,
    EditBaseTopicsComponent
  ],
  imports: [
    PickListModule,
    NgxCoolDialogsModule.forRoot(
      {
        theme: 'default', // available themes: 'default' | 'material' | 'dark'
        okButtonText: 'Oui',
        cancelButtonText: 'Non',
        color: '#004770',
        titles: {
          alert: 'Danger!',
          confirm: 'Confirmation',
          prompt: 'Website asks...'
        }
      }
    ),
    NgScrollbarModule,
    InputTextareaModule,
    TableModule,
    BrowserModule,
    HttpClientModule,
    SimpleNotificationsModule.forRoot({
      position: ["bottom", "left"],
      timeOut: 2500,
      showProgressBar: true,
      pauseOnHover: true,
      clickIconToClose: true,
      preventDuplicates: true,
      theClass: 'error-notification'
    }),
    TooltipModule,
    MessageModule,
    MessagesModule,
    SplitButtonModule,
    MenuModule,
    DropdownModule,
    NgxSpinnerModule,
    CheckboxModule,
    MyDateRangePickerModule,
    BrowserAnimationsModule,
    FormsModule,
    CardModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    TagInputModule,
    HttpModule,
    CheckboxModule,
    ToastModule,
    ListboxModule,
    DialogModule,
    ConfirmDialogModule,
    FileUploadModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' // set defaults here
    }),
    NgxSmartModalModule.forRoot(),
    // CAP-40007 TCL-2727 - Register angular-oauth2-oidc for PingFederate authentication
    OAuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AgGridModule.withComponents(
      []
  ),
    RouterModule.forRoot(appRoutes,{ useHash: true}),
    SnackbarModule.forRoot()
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
    ],
  providers: [
    BillingService,
    InformationImageService,
    NgxSpinnerService,
     NgxSmartModalService,
    MessageService,
    ConfirmationService,
    AuthGuardService,
    AuthService,
    // CAP-40007 TCL-22 - Provide RBAC services explicitly (also providedIn root).
    AuthorizationService,
    RoleGuardService,
    AppConfig,
    // CAP-40007 TCL-2727 - OidcAuthService added to deps so configure() is called after config loads.
    { provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig, OidcAuthService], multi: true
    },
    ImageService,
    // CAp-40007 TCL-2727 - Register JWT AuthInterceptor for all HTTP requests
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {provide: LocationStrategy, useClass: HashLocationStrategy}
      ],
  bootstrap: [AppComponent]
})
export class AppModule{
 


}
